import { compose, createStore } from 'redux';

import createRootReducer from './rootReducers';

// Redux DevTools Extension for Chrome and Firefox
const reduxDevTool = () => {
  return typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__()
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : f => f;
};

export default function configureStore(initialState) {
  const composedStoreEnhancer = compose(reduxDevTool());

  const store = composedStoreEnhancer(createStore)(
    createRootReducer(),
    initialState
  );

  if (import.meta.webpackHot) {
    import.meta.webpackHot.accept('./rootReducers', () => {
      store.replaceReducer(createRootReducer());
    });
  }

  return store;
}
